// extracted by mini-css-extract-plugin
export default {"subheader":"SubHeaderH3_subheader__V7hJg"};